import { AxiosError } from 'axios'
import { extractApiErrorMessage } from '@/lib/api-error'
import { toast } from 'sonner'

export function handleServerError(error: unknown) {
  // eslint-disable-next-line no-console
  console.log(error)

  let errMsg = 'Something went wrong!'

  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    Number(error.status) === 204
  ) {
    errMsg = 'Content not found.'
  }

  if (error instanceof AxiosError) {
    errMsg = extractApiErrorMessage(error, 'Request failed')
  }

  toast.error(errMsg)
}
